import styled from "styled-components";
import { forwardRef } from "react";

import Text from "@/components/Text";
import HomeProductCard from "./HomeProductCard";
import HomeMoreUpcoming from "./HomeMoreUpcoming";
import { HomeContainer } from "../index";
import Image1 from "@/assets/images-for-home/image-1.png";
import Image2 from "@/assets/images-for-home/image-2.png";
import Image3 from "@/assets/images-for-home/image-3.png";
import Image4 from "@/assets/images-for-home/image-4.png";
import Image5 from "@/assets/images-for-home/image-5.png";
import Image6 from "@/assets/images-for-home/image-6.png";

const productData = [
  {
    title: "All Competitors, All Metrics, One Dashboard",
    image: Image1,
    list: [
      "Curate a list of competitor channels in one place to keep everyone in the team on the same page",
      "Automatically track performance of content in your niche and understand it's trends over time",
      "Filter the list of videos to discover your next inspiration, reference and actionable insight",
    ],
  },
  {
    title: "Discover Trending Topics, Genres and Elements",
    image: Image2,
    list: [
      "Analyse the performance of grouped videos to evaluate trends in a more accurate and trustworthy way",
      "Combine multiple topics and build a foundation for your next piece of content",
      "Boost your research process with up-to-date data-driven insights from the Backbone",
    ],
  },
  {
    title: "Test Content Before Publishing Videos",
    image: Image3,
    list: [
      "Trust real-data and forget your gut-feeling, evaluate video content before publishing it to millions",
      "Boost your return-on-investment by collecting real user-engagement data from your target audience",
      "Optimize your thumbnails, standalone clips and final video sequences for the best monetisation",
    ],
  },
  {
    title: "Schedule and Automate Content Distribution",
    image: Image4,
    list: [
      "Set up distribution flows and automate them to post at the right time and channel",
      "Plan your publishing schedule and be few steps ahead of your competition",
      "Get Machine Learning insights how to optimize your publishing schedule",
    ],
  },
  {
    title: "Automate Manual Work and Focus on Creativity",
    image: Image5,
    list: [
      "Create more content variations in a fraction of time by utilizing pre-built automation tools",
      "Save the time of your creative team so that they could create and innovate",
      "Optimise resources and invest in quality, Backbone will take care of the quantity ",
    ],
  },
  {
    title: "Manage Freelancers and Invoices ",
    image: Image6,
    list: [
      "Manage the time and invoices of your team in a single user-friendly dashboard",
      "Calculate performance-focused bonuses to boost the motivation of the team",
      "Export performance reports and financial spreadsheets for in-depth analyses",
    ],
  },
];

const Section = styled.section`
  padding: 56px 0;
`;

const SubHeading = styled(Text)`
  margin-bottom: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
`;

const Break = styled.span`
  background: ${({ theme }) => theme.colors.purpleLighter};
  border-radius: 100px;
  width: 24px;
  height: 2px;
  margin-right: 12px;
  flex-shrink: 0;
`;

const HeadingsLeft = styled.div`
  width: 40%;
`;

const HeadingsRight = styled.div`
  width: 49%;
`;

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 48px;
`;

const Description = styled(Text)`
  line-height: 22px;
  margin-top: 38px;
`;

const HomeProduct = forwardRef<HTMLDivElement | null>((_, ref) => {
  return (
    <Section ref={ref}>
      <HomeContainer>
        <HeadingsRow>
          <HeadingsLeft>
            <SubHeading $type="captionSemibold" $color="gray">
              <Break />
              WHAT IS BACKBONE
            </SubHeading>
            <Text $type="heading1" as="h2">
              Data Infrastructure In A Single Place
            </Text>
          </HeadingsLeft>
          <HeadingsRight>
            <Description $type="captionSemibold" $color="gray">
              Stop wasting your time manually copy-pasting metrics one-by-one
              into spreadsheets to analyse one-time report...
            </Description>
          </HeadingsRight>
        </HeadingsRow>
        {productData.map((item, index) => (
          <HomeProductCard
            key={index}
            count={index + 1}
            data={item}
            isReversed={!!(index % 2)}
          />
        ))}
        <HomeMoreUpcoming />
      </HomeContainer>
    </Section>
  );
});

export default HomeProduct;
